











































































import { Component, Vue } from 'vue-property-decorator';
import { emailApis, MailingListRecord } from '@/api/email.api';

@Component
export default class ImportMembersDialog extends Vue {
  dialogVisible = false;
  currentList: MailingListRecord | null = null;
  step = 1;
  inputType: 'numbers' | 'usernames' | 'emails' = 'numbers';
  inputText = '';
  resolvedEmails: string[] = [];
  validating = false;
  submitting = false;

  get inputPlaceholder(): string {
    if (this.inputType === 'numbers') return '请输入工号，例如：\n00004886\n00004887';
    if (this.inputType === 'usernames') return '请输入用户名，例如：\nzhangsan\nlisi';
    return '请输入邮箱，例如：\nzhangsan@example.com\nlisi@example.com';
  }

  open(listRecord: MailingListRecord) {
    this.currentList = { ...listRecord };
    this.step = 1;
    this.inputType = 'numbers';
    this.inputText = '';
    this.resolvedEmails = [];
    this.dialogVisible = true;
  }

  handleClose() {
    this.dialogVisible = false;
    this.currentList = null;
    this.step = 1;
    this.inputType = 'numbers';
    this.inputText = '';
    this.resolvedEmails = [];
  }

  parseInput(): string[] {
    return this.inputText
      .split(/[\n,\s]+/)
      .map(s => s.trim())
      .filter(s => s.length > 0);
  }

  async handleValidate() {
    const values = this.parseInput();
    if (values.length === 0) {
      this.$message.warning('请输入至少一条内容');
      return;
    }

    if (this.inputType === 'emails') {
      this.resolvedEmails = values;
      this.step = 2;
      return;
    }

    try {
      this.validating = true;
      const result = await emailApis.mailingListsImportValidate(
        this.inputType === 'numbers' ? { numbers: values } : { usernames: values }
      );
      if (!result.items || result.items.length === 0) {
        this.$message.warning('未解析到任何邮箱，请检查输入内容');
        return;
      }
      this.resolvedEmails = result.items;
      this.step = 2;
    } catch (error) {
      this.$message.error(`验证失败: ${error.message || error}`);
    } finally {
      this.validating = false;
    }
  }

  async handleSubmit() {
    if (!this.currentList || this.resolvedEmails.length === 0) {
      return;
    }

    try {
      await this.$confirm(
        `确定要导入 ${this.resolvedEmails.length} 个成员到 "${this.currentList.name}" 吗？`,
        '导入成员确认',
        { type: 'warning' }
      );
    } catch {
      return;
    }

    try {
      this.submitting = true;
      await emailApis.mailingListsModify(this.currentList.name, {
        action: 'addItem',
        members: this.resolvedEmails
      });
      this.$message.success('导入成员成功');
      this.$emit('success');
      this.handleClose();
    } catch (error) {
      this.$message.error(`导入成员失败: ${error.message || error}`);
    } finally {
      this.submitting = false;
    }
  }
}
